<template>
	<div class="prog_reg-body theme-light text-center">
		<div class="container">
			<div class="row">
				<div class="col-12 col-md-12">
					<div class="title">
						Оплата и подтверждение
					</div>
				</div>
			</div>
			<div class="row " v-if="getInvoiceStatus(formData.id) === PAYMENT_STATUS_WAITING_FOR_PAYMENT">
				<div class="col-12 col-md-12">
					Получаем информацию о платеже. Подтверждение оплаты будет отправлено вам на почту.
				</div>
				<div class="col-12 col-md-12">
					<b-spinner
						style="margin-right: 15px; width: 1.3em; height: 1.3em;"
					/>
				</div>
			</div>
		</div>

		<div v-if="getInvoiceStatus(formData.id) === PAYMENT_STATUS_SUCCESS">
			<div class="container">
				<div class="row">
					<div class="col-12 col-md-12 mb-4">
						Спасибо! Ваш платеж принят. Подтверждение оплаты будет отправлено вам на почту
					</div>
				</div>
			</div>

			<document-info-message v-if="!formData.disable_step_4" :form-data="formData" />

			<div class="container">
				<div class="row">
					<div class="col-12 col-md-12 col-lg-12" v-if="getInvoiceStatus(formData.id) === PAYMENT_STATUS_FAILURE">
						Ошибка при проведении оплаты
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	ACTION_GET_INVOICE_STATUS,
	ACTION_SAVE_FORM_DATA_BACKEND,
	CHECKOUT_STORE_NAMESPACE,
	MUTATION_SET_FORM_META_DATA,
} from '@/store/checkout';
import checkoutForm from '@/mixins/checkoutForm';
import DocumentInfoMessage from '@/components/checkout/DocumentInfoMessage.vue';
import {
	PAYMENT_STATUS_WAITING_FOR_PAYMENT,
	PAYMENT_STATUS_SUCCESS,
	PAYMENT_STATUS_FAILURE,
} from './paymentStatusDictionary';

export default {
	name: 'PaymentResult',
	components: {
		DocumentInfoMessage,
	},
	mixins: [checkoutForm],
	props: [
		'formData',
	],
	data() {
		return {
			statusPolling: null,
			PAYMENT_STATUS_WAITING_FOR_PAYMENT,
			PAYMENT_STATUS_SUCCESS,
			PAYMENT_STATUS_FAILURE,
		};
	},
	computed: {
		...mapGetters({
			getInvoiceStatus: 'checkout/getInvoiceStatus',
		}),
	},
	mounted() {
		if (this.getInvoiceStatus(this.formData.id) === PAYMENT_STATUS_WAITING_FOR_PAYMENT) {
			this.statusPolling = setInterval(() => this.checkInvoiceStatus(), 5000);
		}
	},
	methods: {
		async checkInvoiceStatus() {
			await this.$store.dispatch(`${CHECKOUT_STORE_NAMESPACE}/${ACTION_GET_INVOICE_STATUS}`,
				{ formId: this.formData.id });

			if (this.getInvoiceStatus(this.formData.id)) {
				clearInterval(this.statusPolling);
			}
		},
		goToDocuments() {
			this.$store.commit(
				`${CHECKOUT_STORE_NAMESPACE}/${MUTATION_SET_FORM_META_DATA}`,
				{
					meta: { step: 4 },
					formId: this.formData.id,
				},
			);

			this.$store.dispatch(
				`${CHECKOUT_STORE_NAMESPACE}/${ACTION_SAVE_FORM_DATA_BACKEND}`,
				{ formId: this.formData.id },
			);
		},
	},
};
</script>

<style lang="scss" scoped>
	.alert-circle-red {
		&::before {
			content: url("data:image/svg+xml;charset=UTF-8, <svg width='1rem' height='1rem' viewBox='0 0 16 16' class='bi bi-exclamation-circle' fill='#721c24' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z'/><path d='M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z'/></svg>");
			background-size: 1.3rem 1.3rem;
			height: 1.3rem;
			width: 1.3rem;
			margin-right: 1rem;
		}
	}
</style>
